<template lang="pug">
el-dialog(:title="title"
          :visible.sync="visible"
          width="50%"
          destroy-on-close
          :before-close="handleClose")
  .form
    el-form(ref="form" :model="form" :rules="rules" size="small" label-width="120px" inline)
      el-form-item(label="用户类型" prop="userType")
        el-select(v-model="form.userType")
          el-option(v-for="item in userTypeOpt" :key="item.value" :label="item.label" :value="item.value")
      el-form-item(label="用户姓名" prop="userName" maxlength="60")
        el-input(v-model="form.userName")
      el-form-item(v-if="form.userType!=='0'" label="手机号" prop="phoneNumber")
        el-input(v-model="form.phoneNumber" maxlength="11")
      el-form-item(v-if="form.userType==='0'" label="关联下单员电话" prop="orderManPhoneNumber")
        el-input(v-model="form.orderManPhoneNumber" maxlength="11")
      el-form-item(v-if="form.userType==='0'" label="交易平台" prop="platform")
        el-select(v-model="form.platform")
          el-option(v-for="item in platformOpt"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled")
      el-form-item(v-if="form.userType==='0'" label="apiKey" prop="apiKey")
        el-input(v-model="form.apiKey")
      el-form-item(v-if="form.userType==='0'" label="secretKey" prop="secretKey")
        el-input(v-model="form.secretKey")
      el-form-item(v-if="form.userType==='0' && form.platform==='3'" label="passPhrase" prop="passPhrase")
        el-input(v-model="form.passPhrase")
      el-form-item(v-if="form.userType==='0'" label="apiReadWrite" prop="apiReadWrite")
        el-select(v-model="form.apiReadWrite")
          el-option(label="只读" :value="'0'")
          el-option(label="读写" :value="'1'")
      el-form-item(label="邮箱" prop="email")
        el-input(v-model="form.email" maxlength="60")
      el-form-item(v-if="form.userType==='0'" label="用户说明" prop="comments")
        el-input(v-model="form.comments" maxlength="90")
      el-form-item(class="footer")
        el-button(type="primary" @click="submit('form')") 提交
        el-button(v-if="!isEdit" @click="reset('form')") 重置
</template>

<script>
import { addOrUpdateUser } from 'api/user';
import { USER_TYPE, PLATFORM } from 'const';
import deepCopy from 'utils/deepCopy';

const defaultForm = {
  userName: '',
  phoneNumber: '',
  email: '',
  userType: '0',
  orderManPhoneNumber: '',
  platform: '3',
  apiKey: '',
  secretKey: '',
  passPhrase: '',
  apiReadWrite: '1',
  comments: '',
};

export default {
  data() {
    return {
      isEdit: false,
      userType: USER_TYPE,
      platform: PLATFORM,
      visible: false,
      form: deepCopy(defaultForm),
      rules: {
        userName: [{ required: true, message: '请输入用户姓名' }],
        phoneNumber: [
          { required: true, message: '请输入手机号' },
          // { type: 'number', message: '必须为数字值' },
        ],
        userType: [{ required: true, message: '请输入用户类型' }],
        orderManPhoneNumber: [
          { required: true, message: '请输入关联下单员手机号' },
          // { type: 'number', message: '必须为数字值' },
        ],
        platform: [{ required: true, message: '请输入平台代号' }],
        apiKey: [{ required: true, message: '请输入apiKey' }],
        secretKey: [{ required: true, message: '请输入secretKey' }],
        passPhrase: [{ required: true, message: '请输入passPhrase' }],
        apiReadWrite: [{ required: true, message: '请输入apiReadWrite' }],
      },
    };
  },
  computed: {
    title() {
      return `${this.form.phoneNumber ? '编辑' : '新增'}用户`;
    },
    userTypeOpt() {
      return this.userType.map((item, idx) => ({ label: item, value: idx.toString() }));
    },
    platformOpt() {
      const res = this.platform.map((item, idx) => ({ label: item, value: idx.toString() }));
      res[0].disabled = true;
      return res;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    open(model) {
      this.visible = true;
      if (model) {
        this.form = deepCopy(model);
        this.isEdit = true;
      } else {
        this.form = deepCopy(defaultForm);
        this.isEdit = false;
      }
    },
    handleClose(done) {
      done();
    },
    async submit(ref) {
      this.$refs[ref].validate(async (valid) => {
        if (valid) {
          const res = await addOrUpdateUser(this.form).catch(() =>
            this.$message.error('添加或更新用户发生错误'),
          );
          if (res.code === 0) {
            this.$message.success('操作成功');
            this.visible = false;
            window.location.reload();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        } else {
          this.$message.error('请检查输入');
          return false;
        }
      });
    },
    reset(ref) {
      this.$refs[ref].resetFields();
      this.form = deepCopy(defaultForm);
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  display: block;
  text-align: center;
}
</style>
